<template>
  <div class="comment-dialog-container" v-if="commentDialogState">
    <div class="comment-dialog-mask" @touchmove.prevent @click.stop="handleClose"></div>
    <div class="comment-dialog-content" :class="{ 'android-browser': isAndroidBrowser }">
      <w-auto-textarea v-model="commentText" class="w-textarea-container" placeholder="添加点评" ref="WAutoTextarea" :font-max-size="fontMaxSize + 1" />
      <button class="comment-send-btn flex-center" @click="getCommentValue" :disabled="!commentText.length">发布</button>
    </div>
  </div>
</template>

<script>
  import WAutoTextarea from '../../../../components/global/w-auto-textarea'
  import {envMixin} from "../../../../assets/js/mixin/global";
  import {mapActions} from 'vuex'
  import {componentsMixin} from "../../../../assets/js/mixin/components";

  export default {
    name: 'commentDialog',
    mixins: [envMixin, componentsMixin],
    props: {
      commentDialogState: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        commentText: '',
        fontMaxSize: 200,
        scrollY: 0
      }
    },
    mounted() {},
    computed: {},
    watch: {
      commentDialogState(val) {
        if (val) {
          this.scrollY = window.scrollY
          this.$nextTick(() => {
            this.$refs.WAutoTextarea.calcHeight()
            this.$refs.WAutoTextarea.onFocus()
          })
        } else if (this.isIosBrowser) {
          window.scrollTo(0, this.scrollY)
        }
      },
      commentText(val) {
        if (val.length > this.fontMaxSize) {
          // this.commentText = this.commentText.slice(0, this.fontMaxSize)
          this.showToast('已达字数上限', 1500)
          this.$nextTick(() => {
            let el = document.querySelector('.cube-popup-content')
            el.style.top = '-15%'
          })
        }
      }
    },
    components: {
      WAutoTextarea
    },
    methods: {
      ...mapActions('cvShare', [ 'addCommentForCv' ]),
      // 发布评论
      async getCommentValue() {
        try {
          let payload = { comment: this.commentText }
          let res = await this.addCommentForCv({ payload })
          if (res.code === 1000) {
            this.commentText = ''
          }
          this.$emit('addCommentValue', res)
        } catch (e) {
          console.log(e)
        }
      },
      handleClose() {
        this.$emit('handleClose')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/scss/global/variable";
  @import "../../../../assets/scss/global/mixin";
  .comment-dialog-container {
    position: fixed;
    top: 0;
    z-index: 401;
    height: $screen-height;
    .comment-dialog-mask {
      position: fixed;
      height: $screen-height;
      width: 100vw;
      top: 0;
      left: 0;
      z-index: 402;
      background-color: rgba($color: #000, $alpha: .5);
    }
    .comment-dialog-content {
      position: absolute;
      bottom: 0;
      z-index: 403;
      display: flex;
      align-items: flex-end;
      background-color: #333333;
      width: 100vw;
      padding-left: 12px;
      padding-top: 12px;
      padding-bottom: 12px;
      .w-textarea-container {
        flex: 1;
        padding: 8px 10px;
        outline: none;
        border: none;
        background-color: $color-title;
        font-size: $font-size-medium-x;
        color: $color-light;
        border-radius: 4px;
        resize: none;
        &::placeholder {
          color: #bcbcbc;
          font-size: $font-size-medium-x;
        }
      }
      .comment-send-btn {
        width: 52px;
        height: 38px;
        outline: none;
        background-color: transparent;
        color: $color-light;
        font-size: $font-size-medium;
        white-space: nowrap;
        border: none;
        &:disabled {
          color: #9c9c9c;
        }
      }
    }
    .android-browser {
      position: fixed;
    }
  }
</style>